import { Routes } from '@angular/router';
import { BlogsGuard } from '../blogs/guards';




import { DiseaseProfileGuard, DiseaseProfilesGuard } from './guards';
import { DiseaseProfilePagesGuard } from './guards/disease-profile-pages.guard';
import { ThemeResetGuard } from './guards/theme-reset.guard';
import { DiseaseProfileMetaGuard } from './guards/disease-profile-meta.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./containers/disease-profile-overview/disease-profile-overview.component').then(m => m.DiseaseProfileOverviewComponent),
    canActivate: [DiseaseProfilesGuard],
    runGuardsAndResolvers: 'paramsOrQueryParamsChange',
    pathMatch: 'full',
    data: {
      breadcrumb: {
        skip: true,
      },
    },
  },
  {
    path: ':diseaseProfileId/:title',
    loadComponent: () => import('./containers/disease-profile/disease-profile.component').then(m => m.DiseaseProfileComponent),
    canActivate: [DiseaseProfileGuard, DiseaseProfilePagesGuard, BlogsGuard, DiseaseProfileMetaGuard],
    canDeactivate: [ThemeResetGuard, DiseaseProfilePagesGuard],
    data: {
      breadcrumb: {
        label: ':title',
      },
    },
  },
  {
    path: ':diseaseProfileId/:title/informatie/:contentType',
    loadComponent: () => import('./containers/disease-profile-info/disease-profile-info.component').then(m => m.DiseaseProfileInfoComponent),
    canActivate: [DiseaseProfileGuard, DiseaseProfilePagesGuard, BlogsGuard],
    canDeactivate: [ThemeResetGuard, DiseaseProfilePagesGuard],
    data: {
      breadcrumb: { skip: true },
      breadcrumbs: [
        {
          label: ':title',
        },
        {
          label: ':contentType',
        },
      ],
    },
  },
  {
    path: ':diseaseProfileId/:title/:diseaseProfilePageId/:title',
    loadComponent: () => import('./containers/disease-profile-page/disease-profile-page.component').then(m => m.DiseaseProfilePageComponent),
    canActivate: [DiseaseProfileGuard, DiseaseProfilePagesGuard, BlogsGuard],
    canDeactivate: [ThemeResetGuard, DiseaseProfilePagesGuard],
    data: {
      breadcrumb: { skip: true },
      breadcrumbs: [
        {
          label: ':title',
        },
      ],
    },
  },
];
